import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3, LL_H_C, ModuleFE_Toaster } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_Expression } from '../../../_entity.js';
import { BadImplementationException, removeDBObjectKeys, voidFunction } from '@nu-art/ts-common';
import { Component_ExpressionBuilder, Panel_ExpressionSidePanel } from '../../../expression.js';
import { UtilObject_Expression } from '../../../_entity/expression/util-object.js';
import './Manager_Expression.scss';
export class Manager_Expression extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.readonly)
            state.renderArgs = { ...state.renderArgs, editMode: false };
        if (state.renderArgs.itemId !== state.expression?.item._id) {
            const expression = ModuleFE_Expression.cache.unique(state.renderArgs.itemId);
            if (!expression)
                throw new BadImplementationException(`Could not get expression for id ${state.renderArgs.itemId}`);
            state.expression = new EditableDBItemV3(expression, ModuleFE_Expression)
                .setAutoSave(!state.renderArgs.readonly)
                .setOnChanged(async () => this.forceUpdate());
        }
        return state;
    }
    // ######################## Logic ########################
    onCopyExpression = async (expressionId) => {
        const expressionToCopy = ModuleFE_Expression.cache.unique(expressionId);
        if (!expressionToCopy) {
            ModuleFE_Toaster.toastError('Could not find expression to copy');
            return;
        }
        const data = { ...removeDBObjectKeys(expressionToCopy), label: expressionToCopy.label + ' - Copy' };
        try {
            const newExpression = await ModuleFE_Expression.v1.upsert(data).executeSync();
            UtilObject_Expression.openEditor(newExpression, { readonly: this.state.renderArgs.readonly });
        }
        catch (err) {
            this.logError(err);
        }
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_H_C, { className: 'manager-expression', children: [_jsx(Component_ExpressionBuilder, { editable: this.state.expression, deselectExpression: voidFunction, copyExpression: this.onCopyExpression, slimHeader: true }), _jsx(Panel_ExpressionSidePanel, { editable: this.state.expression })] });
    }
}
//# sourceMappingURL=Manager_Expression.js.map